import { getBannerCalendarEventId } from '@esentai/core/features/campaigns/banner/selectors';
import { findCalendarEventById } from '@esentai/core/features/campaigns/calendarEvent/actions';
import { isLoadingEvent } from '@esentai/core/features/campaigns/calendarEvent/selectors';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import CampaignReference from '@/features/campaignCreatePage/EditPage/SecondStepBanner/CampaignInlineSearch/Suggestion';
import withItemApiRunner from '@/hocs/withItemApiRunner';

const mapStateToProps = (state, { itemId }) => {
  const calendarEventId = getBannerCalendarEventId(state, itemId);

  return {
    isLoading: isLoadingEvent(state, calendarEventId),
    itemId: calendarEventId,
  };
};

const mapDispatchToProps = { fetchItem: findCalendarEventById };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withItemApiRunner(),
)(CampaignReference);
